import React, { useContext, useEffect, useState } from "react";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Typography,
} from "@mui/material";
import { FilterContext } from "../../context/Filter";
import { fetchamcExpiredContTable } from "./apiInsights";

const Amcexpiredtb = () => {
    const { superArn: parArn, childArn } = useContext(FilterContext);
    const [amcExpiredContTable, setAmcExpiredContTable] = useState([]);

    const key = childArn ? "childArn" : "parArn";
    const value = childArn || parArn;
    const payload = { [key]: value };

    const getamcExpiredContTable = async () => {
        try {
            // console.log("🚀 Fetching AMC Expired Contracts:", payload);
            const res = await fetchamcExpiredContTable(payload);
            // console.log("✅ Response:", res);
            setAmcExpiredContTable(res?.data || []);
        } catch (error) {
            console.error("❌ Error fetching AMC Expired Table:", error);
        }
    };

    useEffect(() => {
        getamcExpiredContTable();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const columns = [
        { id: "index", label: "#" },
        { id: "assetNumber", label: "Asset No." },
        { id: "registrationNumber", label: "Reg. No." },
        { id: "amcEndDate", label: "AMC End Date" },
        { id: "amcNumber", label: "AMC No." },
    ];

    return (
        <Paper
            elevation={3}
            sx={{
                p: 3,
                borderRadius: 3,
                maxWidth: "80%",
                mx: "auto",
                border: "1px solid #e0e0e0",
                backgroundColor: "#fff",
            }}
        >
            <Typography
                variant="h6"
                sx={{ textAlign: "center", mb: 2, fontWeight: 600, color: "#1e293b" }}
            >
                AMC Expired Contract Table
            </Typography>

            <TableContainer
                sx={{
                    maxHeight: 350,
                    border: "1px solid #d1d5db",
                    borderRadius: 2,
                    overflowY: "auto",
                }}
            >
                <Table stickyHeader size="small">
                    <TableHead>
                        <TableRow sx={{ backgroundColor: "#267CB8" }}>
                            {columns.map((col) => (
                                <TableCell
                                    key={col.id}
                                    sx={{
                                        backgroundColor: "#267CB8",
                                        color: "white",
                                        fontWeight: 600,
                                        textAlign: "center",
                                        border: "1px solid #1e4f7a",
                                    }}
                                >
                                    {col.label}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {amcExpiredContTable && amcExpiredContTable.length > 0 ? (
                            amcExpiredContTable.map((row, index) => (
                                <TableRow
                                    key={index}
                                    sx={{
                                        backgroundColor: index % 2 === 0 ? "#f9fafb" : "#ffffff",
                                        "&:hover": { backgroundColor: "#eff6ff" },
                                        transition: "background-color 0.2s ease-in-out",
                                    }}
                                >
                                    {columns.map((col) => (
                                        <TableCell
                                            key={col.id}
                                            sx={{
                                                textAlign: "center",
                                                border: "1px solid #e5e7eb",
                                                color: "#374151",
                                                py: 1,
                                            }}
                                        >
                                            {row[col.id] || "-"}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            ))
                        ) : (
                            <TableRow>
                                <TableCell
                                    colSpan={columns.length}
                                    sx={{
                                        textAlign: "center",
                                        color: "#6b7280",
                                        py: 3,
                                        border: "1px solid #e5e7eb",
                                    }}
                                >
                                    No data available
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
        </Paper>
    );
};

export default Amcexpiredtb;
